// extracted by mini-css-extract-plugin
export default {"center_box":"index_center_box_6gMWK"};